import { render, staticRenderFns } from "./integralPeopleItemImport.vue?vue&type=template&id=15b1d35c&"
import script from "./integralPeopleItemImport.vue?vue&type=script&lang=js&"
export * from "./integralPeopleItemImport.vue?vue&type=script&lang=js&"
import style0 from "./integralPeopleItemImport.vue?vue&type=style&index=0&id=15b1d35c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports